import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/parks/page', data, {
    trim: true
  })
}

// 所属停车场列表
export function findList (data) {
  return request.post('/business/parks/findList', data, {
    trim: true
  })
}

export function syncParks (data) {
  return request.post('/business/hksync/syncParks', data)
}

